export default "__VITE_ASSET__nMwfSXYb__"